<template>
  <v-lazy-image 
    v-if="lazy"
    :src="x1"
    :alt="alt"
    :srcset="`${x1Image}, ${x2Image}`"
    :src-placeholder="placeholder || ''"
    :class="$style.image"
    use-picture>
    <source 
      :srcset="webp" 
      :alt="alt"
      type="image/webp"
    >
  </v-lazy-image>

  <picture 
    v-else 
    :class="$style.host">
    <source 
      :srcset="webp" 
      :alt="alt"
      :class="$style.image"
      type="image/webp" 
    >
    <img 
      :srcset="`${x1Image}, ${x2Image}`" 
      :alt="alt"
      :class="$style.image"
      decoding="async"
    >
  </picture>
</template>

<script>
/**
 * Base image component.
 */
export default {
  name: 'AppImage',
  props: {
    /**
     * x1 source (default src).
     */
    x1: { type: String, default: '' },
    /**
     * x2 source.
     */
    x2: { type: String, default: '' },
    /**
     * Source with WebP format.
     */
    webp: { type: String, default: '' },
    /**
     * Alt name.
     */
    alt: { type: String, default: '' },
    /**
     * Is lazy image.
     */
    lazy: { type: Boolean, default: false },
    /**
     * Placeholder image while lazy loading.
     */
    placeholder: { type: String, default: '' },
  },
  computed: {
    /**
     * x1 srcset.
     */
    x1Image() {
      return this.x1 ? `${this.x1} 1x` : '';
    },
    /**
     * x2 srcset.
     */
    x2Image() {
      return this.x2 ? `${this.x2} 2x` : '';
    },
  },
};
</script>

<style module>
.image,
.image img {
  width: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/AppImage.vue